export default "__VITE_ASSET__DoQfWYH1__"